import React from 'react';
import { translate } from 'react-i18next';
import { createRoute } from 'lib/util';
import * as Common from 'common/components';

const { Form } = Common;

const AccountsListHeader = ({ canAdd = false, companyId = '', subcompanyId = '', t }) => {
  return <Common.Header title={t('accounts.accounts_title')}></Common.Header>;
};

export default translate()(AccountsListHeader);



// WEBPACK FOOTER //
// src/modules/secured/modules/accounts/components/list/AccountsListHeader.js